
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"#CFF2D0"}}),_c('path',{attrs:{"fill":"#008009","d":"M2.15 8.981h2.352v2.326h1.214V8.98H8.07V7.767H5.716V5.441H4.502v2.326H2.15v1.214zm9.336 2.519h1.386V3.75h-1.38L9.465 5.172v1.305l1.929-1.364h.09V11.5z"}})])
          )
        }
      }
    